import { Rndm } from './Rndm.js';
import { Arry } from './Arry.js';
import { V2, XY } from './V2.js';

export type hkks_type = {
    id: string;
    readonly type: "hkks";
    pos: XY;
    start: XY;
    kill: () => void;
    [key: string]: any;
}

export interface hkks_manager_type {
    list: hkks_type[];
    get: (id: string) => hkks_type | null;
    make: (io?: any) => hkks_type;
}

export function hkks_manager(): hkks_manager_type {
    const self = {
        list: [] as hkks_type[],
        get: function (id: string): hkks_type | null {
            return Arry.get.id(this.list, id) as hkks_type | null;
        },
        kill: function (id: string): void {
            const find_hook = this.get(id);
            if (find_hook) find_hook.kill();
        },
        make: function (io: any = {}): hkks_type {
            const h = {
                ...io,
                type: "hkks",
                id: io.id || Rndm.id(),
                pos: io.pos || V2.new.random(),
                start: { x: 0, y: 0 },
                kill: function () {
                    Arry.remove.id(self.list, this.id);
                }
            };

            if (typeof io.x === "number") h.pos.x = io.x;
            if (typeof io.y === "number") h.pos.y = io.y;
            h.start.x = h.pos.x;
            h.start.y = h.pos.y;

            this.list.push(h);
            return h;
        }
    };
    return self;
}